export const TTL_FIVE_MINUTES = 5 * 1000 * 60;
export const TTL_SEVEN_DAYS = 7 * 1000 * 60 * 60 * 24;
export const LOCAL_STORAGE_KEY = 'shoppingCart.cartOverview';
export const ORDER_RECAP = 'order_recap';
export const CART_OVERVIEW_SAGA_KEY = 'cartOverview';
export const CART_PAGE = 'cart';
